import type { ComponentType } from "react"
import type { WidgetType, WidgetProps } from "./widget-types"
import { WelcomeKpiWidget } from "components/widgets/welcome-kpi-widget"
import { QuickActionsWidget } from "components/widgets/quick-actions-widget"
import { TaskStatusWidget } from "components/widgets/task-status-widget"
import { TodayAgendaWidget } from "components/widgets/today-agenda-widget"
import { TeamStatusWidget } from "components/widgets/team-status-widget"
import { LastInteractionsWidget } from "components/widgets/last-interactions-widget"
import { NotesWidget } from "components/widgets/notes-widget"
export const widgetRegistry: Record<WidgetType, ComponentType<WidgetProps & { onOpenNote?: () => void }>> = {
  welcomeKpi: WelcomeKpiWidget,
  quickActions: QuickActionsWidget,
  taskStatus: TaskStatusWidget,
  todayAgenda: TodayAgendaWidget,
  teamStatus: TeamStatusWidget,
  lastInteractions: LastInteractionsWidget,
  notes: NotesWidget,
}
